import { Draggable, Droppable } from '@hello-pangea/dnd';

import { FormItem } from '../../../models/Inquiry/Inquiry';

interface Props {
  data: FormItem[] | undefined
  isLoading: boolean
  droppableId: string
}

export default function FormItems({
  data,
  isLoading,
  droppableId,
}: Props): JSX.Element {
  return (
    <>
      <div className="fw-bold mb-1">＜追加項目＞</div>
      {
        isLoading && (
          <div className="spinner-border spinner-border-sm text-primary mt-2" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )
      }
      <Droppable
        droppableId={droppableId}
        isDropDisabled
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            className="list-group gap-1 webdb-list-additems"
            style={{ minHeight: '200px' }}
          >
            {!isLoading && data?.map((item, index) => (
                  <Draggable
                    key={item.uuid}
                    index={index}
                    draggableId={String(item.uuid)}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="user-select-none list-group-item list-group-item-action"
                        style={{
                          ...provided.draggableProps.style,
                          display: item.hide ? 'none' : 'block',
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <i className="fa-solid fa-bars fa-fw me-2" />
                          {item.label}
                        </div>
                      </div>
                    )}
                  </Draggable>
            ))}

            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </>
  );
}
